/* Keep product context on the current storefront. */
(() => {
  const root = document.querySelector('[data-bm-contact]');
  if (!root) return;
  const params = new URLSearchParams(location.search);
  const product = params.get('product') || '';
  const handle = params.get('handle') || '';
  const input = root.querySelector('#bm-contact-product');
  if (input && !input.value && /^\d{1,20}$/.test(product)) {
    input.value = product;
    root.querySelector('#bm-contact-subject').value = 'product';
    if (/^[a-z0-9][a-z0-9-]{0,254}$/.test(handle)) {
      const link = root.querySelector('[data-bm-contact-product-link]');
      link.href = root.dataset.storeRoot + 'products/' + encodeURIComponent(handle);
      link.hidden = false;
    }
  }
})();
